import {
  DocumentVerificationProvider,
  IncomeStatus,
  VerifyMethodType
} from "shared/types";
import { VerifiedItem } from "../../types/verified";
import { BankSourcesTable } from "./components/BankSourcesTable";
import { PayrollTable } from "./components/PayrollTable";
import { PaystubTable } from "./components/PaystubTable";
import { W2Table } from "./components/W2Table";
import { BankStatementTable } from "./components/BankStatementTable";
import { BankStatementItem } from "../../types/verified/bank-statment";
import { W2Item } from "../../types/verified/w2";
import {
  UploadedIncomeSource,
  VerificationSpecificAdditionaData
} from "../../types/income";
import { BenefitsStatementTable } from "./components/BenefitsStatementTable";
import { PaystubItem } from "../../types/verified/paystub";

export const TablesSlice = ({
  nonEmptyReverifyAttempt,
  incomeStatus,
  additionalData,
  failedW2Sources,
  failedPaystubSources
}: {
  nonEmptyReverifyAttempt: VerifiedItem | VerifiedItem[];
  incomeStatus: IncomeStatus;
  additionalData?: VerificationSpecificAdditionaData | null;
  failedW2Sources?: UploadedIncomeSource[];
  failedPaystubSources?: UploadedIncomeSource[];
}) => {
  if (Array.isArray(nonEmptyReverifyAttempt)) {
    const groupedItemsSourceType =
      nonEmptyReverifyAttempt[0].income_source_type;
    if (groupedItemsSourceType === VerifyMethodType.BankStatement)
      return (
        <BankStatementTable
          incomeItems={nonEmptyReverifyAttempt as BankStatementItem[]}
          incomeStatus={incomeStatus}
          additionalData={additionalData?.[VerifyMethodType.BankStatement]}
        />
      );
    if (groupedItemsSourceType === VerifyMethodType.Paystub)
      return (
        <PaystubTable
          incomeItems={nonEmptyReverifyAttempt as PaystubItem[]}
          provider={DocumentVerificationProvider.Inscribe}
          failedIncomeSources={failedPaystubSources}
        />
      );
    if (groupedItemsSourceType === VerifyMethodType.W2)
      return (
        <W2Table
          incomeItems={nonEmptyReverifyAttempt as W2Item[]}
          failedIncomeSources={failedW2Sources}
        />
      );
  } else
    switch (nonEmptyReverifyAttempt.income_source_type) {
      case VerifyMethodType.Bank:
        return <BankSourcesTable income={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.Payroll:
        return <PayrollTable income={[nonEmptyReverifyAttempt]} />;
      case VerifyMethodType.W2:
        return (
          <W2Table
            incomeItems={[nonEmptyReverifyAttempt]}
            failedIncomeSources={failedW2Sources}
          />
        );
      case VerifyMethodType.Paystub:
        return (
          <PaystubTable
            incomeItems={[nonEmptyReverifyAttempt]}
            provider={DocumentVerificationProvider.Ocrolus}
            failedIncomeSources={failedPaystubSources}
          />
        );
      case VerifyMethodType.BenefitsStatement:
        return (
          <BenefitsStatementTable incomeItems={[nonEmptyReverifyAttempt]} />
        );
    }
};
